import { Injectable } from "@angular/core";
import { GeolocationClient, SubRegion, DTOSubRegion, Region } from "../api/WickedApiClient";
import { Observable, of } from "rxjs";

declare const MOSTPOPULARCITIES60: SubRegion[];

@Injectable({
  providedIn: "root"
})
export class GeolocationService {
  constructor(private geolocationClient: GeolocationClient, ) {

  }

  public CitiesByPopulation(top: number, order = false): Observable<SubRegion[]> {
    if (MOSTPOPULARCITIES60 && top == 60) {
      if(order){
        MOSTPOPULARCITIES60.sort((a,b)=>{
          if(a.name<b.name) return -1
          else return 1;
        });
        return of(MOSTPOPULARCITIES60);
      }else
      return of(MOSTPOPULARCITIES60);
    } else {
      return this.geolocationClient.cityMostPopulation(top);
    }
  }

  public getSubregionDefault(ip?: string): Promise<string> {
    return new Promise<string>((rs, rj) => {
      var sub = this.geolocationClient.getNearestCity(ip).subscribe(r => {
        rs(r);
        sub.unsubscribe();
      });
    });
  }

  public GetSubregionByIP(ip?: string): Promise<SubRegion> {
    return new Promise<SubRegion>((rs, rj) => {
      var sub = this.geolocationClient.getSubregionByIP(ip).subscribe(r => {
        rs(r);
        sub.unsubscribe();
      });
    });
  }

  public GetSubregionByZIP(zip?: string): Promise<SubRegion> {
    return new Promise<SubRegion>((rs, rj) => {
      var sub = this.geolocationClient.getSubregionByZip(zip).subscribe(r => {
        rs(r);
        sub.unsubscribe();
      });
    });
  }

  public GetRegion(regionId: number): Promise<Region> {
    return this.geolocationClient.getRegion(regionId).toPromise<Region>();
  }

  public GetSubregionObservable(subregionId: number): Observable<SubRegion> {
    return this.geolocationClient.getSubregion(subregionId);
  }

  public GetSubregion(subregionId: number): Promise<SubRegion> {
    return this.geolocationClient.getSubregion(subregionId).toPromise<SubRegion>();
  }

  public GetGeolocationSearchModel() {
    return this.geolocationClient.getGeolocationSearchModel();
  }
}
